// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "SelfServStatusRow" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { SelfServMetaStatus } from "./self-serv-meta-status.enum.gen";
import { SelfServBuildReason } from "./self-serv-build-reason.enum.gen";

export const SelfServStatusRowGenShape = z.strictObject({
  configId: z.string(),
  domain: z.string().optional(),
  teamId: z.string(),
  teamName: z.string(),
  status: z.enum(SelfServMetaStatus),
  timestamp: z.string().optional(),
  age: z.string().optional(),
  pending: z.boolean(),
  reason: z.enum(SelfServBuildReason),
  actor: z.string().optional(),
  requestedAt: z.string().optional(),
});
